module.exports = __webpack_public_path__ + "static/media/Buttons_Question Series button.6fa8fe69.png";